import { render } from "./HolidayAdmin.vue?vue&type=template&id=4e1b3c57"
import script from "./HolidayAdmin.vue?vue&type=script&lang=js"
export * from "./HolidayAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__